var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from "react";
export function QuestStringsSettings(_a) {
    var quest = _a.quest, setQuest = _a.setQuest;
    // tslint:disable-next-line:no-useless-cast
    var stringsKeys = ["Ranger", "ToPlanet", "ToStar", "FromPlanet", "FromStar"];
    // tslint:disable-next-line:no-useless-cast
    var legacyStringsKeys = ["Money", "Date"];
    return (React.createElement("div", { className: "p-4" }, __spreadArray(__spreadArray([], __read(stringsKeys)), __read(legacyStringsKeys)).map(function (key) { return (React.createElement("div", { key: key, className: "d-flex align-items-center mb-2" },
        React.createElement("label", { className: "form-check-label " + (legacyStringsKeys.find(function (x) { return x === key; }) ? "text-muted" : ""), style: { flexShrink: 0 } },
            "<",
            key,
            ">"),
        React.createElement("input", { className: "form-control ml-2", value: quest.strings[key], onChange: function (e) {
                var _a;
                return setQuest(__assign(__assign({}, quest), { strings: __assign(__assign({}, quest.strings), (_a = {}, _a[key] = e.target.value, _a)) }));
            } }))); })));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5nc1NldHRpbmdzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3RyaW5nc1NldHRpbmdzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUNBLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBRy9CLE1BQU0sVUFBVSxvQkFBb0IsQ0FBQyxFQUEwQztRQUF4QyxLQUFLLFdBQUEsRUFBRSxRQUFRLGNBQUE7SUFDcEQsMkNBQTJDO0lBQzNDLElBQU0sV0FBVyxHQUFHLENBQUMsUUFBUSxFQUFFLFVBQVUsRUFBRSxRQUFRLEVBQUUsWUFBWSxFQUFFLFVBQVUsQ0FBVSxDQUFDO0lBQ3hGLDJDQUEyQztJQUMzQyxJQUFNLGlCQUFpQixHQUFHLENBQUMsT0FBTyxFQUFFLE1BQU0sQ0FBVSxDQUFDO0lBQ3JELE9BQU8sQ0FDTCw2QkFBSyxTQUFTLEVBQUMsS0FBSyxJQUNqQix1Q0FBSSxXQUFXLFdBQUssaUJBQWlCLEdBQUUsR0FBRyxDQUFDLFVBQUMsR0FBRyxJQUFLLE9BQUEsQ0FDbkQsNkJBQUssR0FBRyxFQUFFLEdBQUcsRUFBRSxTQUFTLEVBQUMsZ0NBQWdDO1FBQ3ZELCtCQUNFLFNBQVMsRUFDUCxtQkFBbUIsR0FBRyxDQUFDLGlCQUFpQixDQUFDLElBQUksQ0FBQyxVQUFDLENBQUMsSUFBSyxPQUFBLENBQUMsS0FBSyxHQUFHLEVBQVQsQ0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLEVBRXRGLEtBQUssRUFBRSxFQUFFLFVBQVUsRUFBRSxDQUFDLEVBQUU7WUFFdkIsR0FBRztZQUNILEdBQUc7WUFDSCxHQUFHLENBQ0U7UUFFUiwrQkFDRSxTQUFTLEVBQUMsbUJBQW1CLEVBQzdCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUN6QixRQUFRLEVBQUUsVUFBQyxDQUFDOztnQkFDVixPQUFBLFFBQVEsdUJBQU0sS0FBSyxLQUFFLE9BQU8sd0JBQU8sS0FBSyxDQUFDLE9BQU8sZ0JBQUcsR0FBRyxJQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsS0FBSyxVQUFLO1lBQTVFLENBQTRFLEdBRTlFLENBQ0UsQ0FDUCxFQXJCb0QsQ0FxQnBELENBQUMsQ0FDRSxDQUNQLENBQUM7QUFDSixDQUFDIn0=